import React from 'react';
import { FaCheck, FaLongArrowAltRight, FaRegClock } from 'react-icons/fa';
import { HiRefresh } from "react-icons/hi";

const PREMIUM = ({ serviceDetails }) => {
    const { pricingDetails } = serviceDetails;
    return (
        <div>
            <div className='flex items-center justify-between'>
                <h1 className='text-xl font-semibold'>PREMIUM</h1>
                <h1 className='text-xl font-semibold'>${pricingDetails?.premium?.price}</h1>
            </div>

            <p className='my-8'>{pricingDetails?.premium?.description}</p>

            <div className='flex gap-5'>
                <div className='flex items-center gap-3 font-semibold'>
                    <FaRegClock ></FaRegClock>
                    <p>{pricingDetails?.premium?.deliveryDate} Day Delivery</p>
                </div>

                <div className='flex items-center gap-3 font-semibold'>
                    <HiRefresh className='h-5 w-5'></HiRefresh>
                    <p>Unlimited Revisions</p>
                </div>
            </div>
            <div className='my-5'>
                {
                    pricingDetails.premium.serviceOptions ? pricingDetails.premium.serviceOptions.map(sop => <div className='flex items-center gap-3'>
                        <FaCheck className='text-[#1DBF73]'></FaCheck>
                        <p>{sop}</p>
                    </div>) : ''
                }
            </div>

            <div className='flex bg-[#1DBF73] justify-evenly px-3 py-2 items-center rounded-md '>
                <button className=' text-xl font-semibold  w-full '>Continue </button>
                <FaLongArrowAltRight className='mr-3'></FaLongArrowAltRight>
            </div>
            <div className='mt-5'>
                <button className='btn btn-outline py-2 capitalize text-lg font-semibold px-3 w-full rounded-md '>Contact Me </button>
            </div>
        </div>
    );
};

export default PREMIUM;